module.exports = __webpack_public_path__ + "static/media/T18.PNG.0effd102.png";